export const LEAVE = "LEAVE";
export const LEAVE_SUCCESS = "LEAVE_SUCCESS";
export const LEAVE_FAILED = "LEAVE_FAILED";

export const ADD_LEAVE = "ADD_LEAVE";
export const ADD_LEAVE_SUCCESS = "ADD_LEAVE_SUCCESS";
export const ADD_LEAVE_FAILED = "ADD_LEAVE_FAILED";

export const ADD_MONTHLY_LEAVE = "ADD_MONTHLY_LEAVE";
export const ADD_MONTHLY_LEAVE_SUCCESS = "ADD_MONTHLY_LEAVE_SUCCESS";
export const ADD_MONTHLY_LEAVE_FAILED = "ADD_MONTHLY_LEAVE_FAILED";

export const UPDATE_LEAVE = "UPDATE_LEAVE";
export const UPDATE_LEAVE_SUCCESS = "UPDATE_LEAVE_SUCCESS";
export const UPDATE_LEAVE_FAILED = "UPDATE_LEAVE_FAILED";